import { Injectable } from '@angular/core';
import { PREVIEW_READY_MESSAGE, handedOverToken } from './share-link-request';

const HANDOVER_TIMEOUT_MS = 15000;

/** Holds the preview token for this page. The Projul app embedding the preview hands it over by message, so the
 *  token never sits in a URL or an iframe `src` that either app could record. */
@Injectable({
  providedIn: 'root'
})
export class PreviewTokenService {
  private current = '';

  get token(): string {
    return this.current;
  }

  /** Asks the embedding app for the token; '' when none arrives, which the page shows as a refused preview. */
  request(win: Window = window, timeoutMs = HANDOVER_TIMEOUT_MS): Promise<string> {
    if (win.parent === win) return Promise.resolve(this.current = '');

    return new Promise(resolve => {
      const finish = (token: string) => {
        clearTimeout(timer);
        win.removeEventListener('message', onMessage);
        this.current = token;
        resolve(token);
      };
      // Any embedder may answer: the server checks the token against this link and its signer, so origin grants nothing.
      const onMessage = (event: MessageEvent) => {
        const token = event.source === win.parent ? handedOverToken(event.data) : '';
        if (token) finish(token);
      };
      const timer = setTimeout(() => finish(''), timeoutMs);
      win.addEventListener('message', onMessage);
      win.parent.postMessage({ type: PREVIEW_READY_MESSAGE }, '*');
    });
  }
}
